import { ErrCapture } from "@/components/ErrCapture"
import { ThemeContextProvider } from "@/contexts/ThemeContext"
import { client } from "@/graphql/index.graphql"
import { routes } from "@/routes"
import { RouteWithSubRoutes } from "@/utils/routerHelper"
import { ApolloProvider } from "@apollo/client"
import React from "react"
import { BrowserRouter, Switch } from "react-router-dom"
import "./App.less"

// need to put more specific match first then the more general match

const App = (): JSX.Element => {
  return (
    <ErrCapture>
      <ApolloProvider client={client}>
        <ThemeContextProvider>
          <BrowserRouter>
            <Switch>
              {routes.map((route: { component: any; path: string }, i: number) => {
                return <RouteWithSubRoutes key={i} {...route} />
              })}
            </Switch>
          </BrowserRouter>
        </ThemeContextProvider>
      </ApolloProvider>
    </ErrCapture>
  )
}

export default App
